import { VFlow } from 'bold-ui'
import { ErrorField } from 'components/form'
import { MetaPath } from 'util/metaPath'
import {
  CuidadoCompartilhadoModel,
  CuidadoCompartilhadoVideochamadaState,
  DiscussaoCasoSolicitanteFieldsModel,
} from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

import { AgendarConsultaCuidadoCompartilhadoField } from '../components/discussao-caso-fields/AgendarConsultaCuidadoCompartilhadoField'
import { PerguntaCuidadoCompartilhadoField } from '../components/discussao-caso-fields/PerguntaCuidadoCompartilhadoField'
import { TrocaExecutanteCuidadoCompartilhadoField } from '../components/discussao-caso-fields/TrocaExecutanteCuidadoCompartilhadoField'
import { OnCondutaGroupChangeCallback } from './DiscussaoCasoFieldGroup'

interface DiscussaoCasoSolicitanteFieldsProps {
  path: MetaPath<DiscussaoCasoSolicitanteFieldsModel>
  cuidadoCompartilhado: CuidadoCompartilhadoModel
  videochamadaUuidState: CuidadoCompartilhadoVideochamadaState
  isEspecializada: boolean
  isExecutanteFromEstabelecimentoEspecializado: boolean
  onCondutaGroupChange: OnCondutaGroupChangeCallback
}

export const DiscussaoCasoSolicitanteFields = (props: DiscussaoCasoSolicitanteFieldsProps) => {
  const {
    path,
    cuidadoCompartilhado,
    videochamadaUuidState,
    isEspecializada,
    isExecutanteFromEstabelecimentoEspecializado,
    onCondutaGroupChange,
  } = props

  const { lotacaoSolicitante, lotacaoExecutanteAtual, unidadeSaudeExecutanteAtual } = cuidadoCompartilhado

  return (
    <VFlow vSpacing={0.5}>
      <PerguntaCuidadoCompartilhadoField path={path} onCondutaGroupChange={onCondutaGroupChange} />

      <TrocaExecutanteCuidadoCompartilhadoField
        path={path}
        lotacaoSolicitante={lotacaoSolicitante}
        profissionalExecutanteId={lotacaoExecutanteAtual.profissional.id}
        equipeExecutanteId={lotacaoExecutanteAtual.equipe?.id}
        unidadeSaudeExecutanteId={unidadeSaudeExecutanteAtual.id}
        isEspecializada={isEspecializada}
        onCondutaGroupChange={onCondutaGroupChange}
      />

      <AgendarConsultaCuidadoCompartilhadoField
        path={path}
        cuidadoCompartilhado={cuidadoCompartilhado}
        videochamadaUuidState={videochamadaUuidState}
        isExecutanteFromEstabelecimentoEspecializado={isExecutanteFromEstabelecimentoEspecializado}
        onCondutaGroupChange={onCondutaGroupChange}
      />

      <ErrorField name={path} ignoreObjectError />
    </VFlow>
  )
}
